import { nextUntil } from './helpers';

document.addEventListener('turbolinks:load', () => {
  const testFeatures = [...document.querySelectorAll('.testFeatureTag')];
  testFeatures.forEach((feature) => {
    if (feature.dataset.id) {
      const siblings = nextUntil(feature, feature.dataset.id);
      siblings.forEach((sibling) => {
        sibling.classList.add('test-feature');
      });
    }
  });
});
